import React from 'react';
import { Box, Image, Typography, BRAND_NAME, BRAND_LOGO_ALT } from '../../../design-system';
import { colors } from '../../../design-system/colors';
import { handleLogoClick } from './handlers/navigationHandlers';
import logo from '../../../../assets/brand/logo_site.svg';

const Logo: React.FC = () => {
  return (
    <Box
      component="button"
      onClick={handleLogoClick}
      aria-label="Go to top of page"
      sx={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        minHeight: '44px',
        minWidth: '44px',
        display: 'flex',
        alignItems: 'flex-end',
        gap: '12px',
        '&:hover': {
          opacity: 0.8,
        },
        '&:focus-visible': {
          outline: `2px solid ${colors.primary[500]}`,
          outlineOffset: '2px',
          borderRadius: '4px',
        },
      }}
    >
      <Image
        src={logo}
        alt={BRAND_LOGO_ALT}
        containerProps={{
          sx: {
            height: { xs: '32px', md: '40px' },
            width: 'auto',
          },
        }}
        imageStyle={{
          height: '100%',
          width: 'auto',
        }}
      />
      <Typography
        variant="headingLarge"
        sx={{
          fontSize: { xs: '1.25rem', md: '1.5rem' },
          fontFamily: 'Outfit, sans-serif',
          fontWeight: 700,
        }}
      >
        <span style={{ color: '#e61d50' }}>Cherry</span>
        <span style={{ color: colors.neutral.white }}>Clipz</span>
        <span style={{ color: '#e61d50', fontFamily: "Impact, 'Arial Black', sans-serif", fontWeight: 900, fontSize: '22px', marginLeft: '10px', letterSpacing: '3px', textShadow: '1px 1px 0px #8b0000' }}>V2</span>
      </Typography>
    </Box>
  );
};

export default Logo;
